var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sb_make_doc" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-lg-12" }, [
        _c(
          "div",
          { staticClass: "panel" },
          [
            _c("make_doc_title", {
              attrs: { title: "Додати звіт про роботу" },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "panel-container show" }, [
              _c("div", { staticClass: "panel-content" }, [
                _c("div", { staticClass: "template p-2" }, [
                  _c(
                    "label",
                    { staticClass: "form-label", attrs: { for: "dt_select" } },
                    [_vm._v("\n\t\t\t\t\t\t\t\tДата: *\n\t\t\t\t\t\t\t")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "select_step" },
                    [
                      _c("date-picker", {
                        attrs: {
                          "value-type": "format",
                          lang: _vm.d_lang,
                          format: "DD-MM-YYYY",
                          confirm: false,
                          disabled: _vm.isEditMode,
                          "first-day-of-week": 1,
                        },
                        model: {
                          value: _vm.form.date_report,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "date_report", $$v)
                          },
                          expression: "form.date_report",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "template p-2" },
                  [
                    _c("service_select", {
                      attrs: { active_id: parseInt(_vm.form.service_id) },
                      on: { on_service_set: _vm.set_service_id },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "template p-2" }, [
                  _c(
                    "label",
                    {
                      staticClass: "form-label",
                      attrs: { for: "payment_online" },
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t\t\t\t\tВведiть коментар\n\t\t\t\t\t\t\t"
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "select_step" },
                    [
                      _c("b-textarea", {
                        attrs: { rows: 5 },
                        model: {
                          value: _vm.form.comment,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "comment", $$v)
                          },
                          expression: "form.comment",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "template p-2" },
                  [
                    _c(
                      "b-container",
                      { staticClass: "pl-1", attrs: { fluid: "" } },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "action_field pb-2 mb-2 row fw-500 border-bottom border-1",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "col-1 np_hd text-left" },
                              [
                                _vm._v(
                                  "\n\t\t\t\t\t\t\t\t\t\t№\n\t\t\t\t\t\t\t\t\t"
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-2 text-center" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t\tПочаток\n\t\t\t\t\t\t\t\t\t"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-2 text-center" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t\tЗакінчення\n\t\t\t\t\t\t\t\t\t"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-5 text-center" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t\tОпис виконаної роботи\n\t\t\t\t\t\t\t\t\t"
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "col-2 text-center" }, [
                              _vm._v(
                                "\n\t\t\t\t\t\t\t\t\t\tТривалість\n\t\t\t\t\t\t\t\t\t"
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "after_change" },
                          [
                            _vm._l(_vm.form.work_items, function (row, idx) {
                              return _c(
                                "div",
                                {
                                  staticClass:
                                    "action_field row flex-nowrap align-items-center pb-2",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "np col-1 text-left" },
                                    [_vm._v(_vm._s(idx + 1))]
                                  ),
                                  _vm._v(" "),
                                  _vm._l(row, function (item, idx2) {
                                    return _c(
                                      "div",
                                      {
                                        staticClass: "field_insert",
                                        class: item.class,
                                      },
                                      [
                                        !_vm.exclusionName.includes(item.name)
                                          ? _c(
                                              "div",
                                              { staticClass: "filed_inside" },
                                              [
                                                item.is_time_pick
                                                  ? _c("b-form-input", {
                                                      key:
                                                        "t_" + idx + "_" + idx2,
                                                      staticClass: "m-0",
                                                      attrs: {
                                                        type: "time",
                                                        placeholder: "HH:mm",
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          return _vm.changeTime(
                                                            idx,
                                                            item
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value: item.value,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "value",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.value",
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                !item.is_time_pick &&
                                                !item.is_editor
                                                  ? _c("b-form-input", {
                                                      key:
                                                        "input_" +
                                                        idx +
                                                        "_" +
                                                        idx2,
                                                      staticClass: "w-100 m-0",
                                                      attrs: {
                                                        placeholder: item.text,
                                                      },
                                                      model: {
                                                        value: item.value,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            item,
                                                            "value",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "item.value",
                                                      },
                                                    })
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        item.name === "time_diff"
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "text-center text-nowrap text-truncate",
                                              },
                                              [
                                                _vm._v(
                                                  "\n\t\t\t\t\t\t\t\t\t\t\t\t" +
                                                    _vm._s(item.value) +
                                                    "\n\t\t\t\t\t\t\t\t\t\t\t"
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    )
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "remove_row",
                                      on: {
                                        click: function ($event) {
                                          return _vm.remove_row(idx)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "fa fa-trash active color-danger-800 cursor-pointer",
                                        attrs: { "aria-hidden": "true" },
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "clr" }),
                                ],
                                2
                              )
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "control title_" }, [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-success",
                                  on: {
                                    click: function ($event) {
                                      return _vm.add_row()
                                    },
                                  },
                                },
                                [_vm._v("Додати")]
                              ),
                            ]),
                          ],
                          2
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "mt-5 d-flex flex-row flex-nowrap align-items-center overflow-hidden",
                  },
                  [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-lg btn-outline-primary waves-effect waves-themed",
                        class: _vm.can_save
                          ? "btn-outline-success"
                          : "btn-outline-danger",
                        attrs: { disabled: !_vm.can_save },
                        on: { click: _vm.save_doc },
                      },
                      [
                        _c("span", {
                          staticClass: "fal",
                          class: {
                            "fa-check mr-1": _vm.can_save,
                            "fa-exclamation-triangle": !_vm.can_save,
                          },
                        }),
                        _vm._v("\n\t\t\t\t\t\t\t\tЗберегти\n\t\t\t\t\t\t\t"),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.isEditMode
                      ? _c(
                          "button",
                          {
                            staticClass: "ml-3 btn btn-lg btn-outline-primary",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.closeDoc.apply(null, arguments)
                              },
                            },
                          },
                          [_vm._v("\n\t\t\t\t\t\t\t\tЗакрити\n\t\t\t\t\t\t\t")]
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
            ]),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }